<template>
  <div> 
    <div class="content-box" v-if="showContent">
    <div class="box" v-show="step == 1 || step == 3 || step == 4">
      <!-- 头部数据-->
      <div class="top-header" :class="{ 'header-fixed': isFixed }">
        <div id="spreadmsed" v-show="videoLink && showVideo" style="padding-top: 150px;width: 750px;"
          :style="{ transition: 'all 0.3s', opacity: showVideo ? 1 : 0 }"> </div>
        <header ref="headerBox">
          <div class="tag-container">
            <div class="tag-row" v-for="(row, rowIndex) in groupedCategories" :key="rowIndex">
              <div class="tag " v-for="(item, s) in row" :class="{ 'tag-active': cate_id === item.id }"
                @click="chooseCate(item.id)">{{ item.name }}</div>
            </div>

          </div>
          <div class="search-box" style="padding:5px;">
            <div style="display: flex;">
              <!-- <van-search style="width: 150px;padding:3px 10px;" v-model="params.key" placeholder="请输入搜索关键词" hape="round" background="none"/>
              <div class="btn-search" @click="searchList">搜 索</div> -->
              <van-search style="width: 180px;padding:0px 10px;border-radius: 25px;" v-model="params.key" show-action
                shape="round" background="#fff" placeholder="搜索视频" @search="searchList">
                <template #action>
                  <div @click="searchList">搜索</div>
                </template>
              </van-search>
            </div>

            <div class="search-new-btn" @click="diushi" v-if="showShouCang"><img style="width: 22px;margin-top: 2px;"
          src="../assets/heart2.png" />{{ typedText }}</div>

            <!-- <van-icon name="play" color="#fff" /> -->

            <div class="searcn-new" @click="webspread">账号中心 </div>
          </div>
          <van-notice-bar left-icon="volume-o" mode="closeable" color="#fff" background="#FCF518"
            text="1.系统每日赠送用户3积分用于观看免费视频;2.为防止您购买的资源丢失,请您购买前后及时在账号中心--注册登录,注册前请勿更换网络环境！！" />
        </header>
      </div>
      <!-- 头部数据-->
      <!-- 列表数据-->
      <div class="list" :style="{ paddingTop: headerHeight + 'px' }" v-show="step == 1">
        <van-list v-model="loading" :immediate-check="true" loading-text="加载中..." :finished="finished"
          finished-text="没有更多了" @load="doGetList" offset="800" direction="down">
          <div class="list-box">
            <div class="list-item" v-for="(item, index) in dataList" :key="index">

              <img v-if="item.is_collect == 0 && params.today != 1" class="heart" src="../assets/heart1.png" alt=""
                @click="collect(item.id, index)" />
              <img v-if="item.is_collect == 1 && params.today != 1" class="heart" src="../assets/heart2.png" alt=""
                @click="resetCollect(item.id, index)" />
              <div class="img-wrap" @click="getDetail(item)">
                <div v-if="item.thumb_image" class="thumb">
                  <span class="times" v-if="item.times">时长:{{ item.times }}</span>
                  <span class="today" v-if="params.today == 1">{{ item.day }}</span>

                  <!-- <img :id="item.number+'_img'" src="" width="100%" @error="resetImgUrl(item.number+'_img',item.thumb_image)" /> -->
                  <img :id="item.number + '_img'" src="" width="100%" v-if="item.is_new == 0" />
                  <img :id="item.number + '_img'" :src="item.thumb_image" width="100%" v-if="item.is_new == 1" />
                </div>
                <div class="img-tips-left" style="background: none;padding:0;">
                  <span
                    style="background: #000;opacity: 0.65;padding: 2px 5px;border-radius: 5px;">已有{{ item.rand }}人看过</span>
                  <span v-if="item.is_free == 1" style="background: green;padding: 2px 5px;border-radius: 5px;">免费</span>
                  <span v-if="item.is_free == 0" style="background: red;padding: 2px 5px;border-radius: 5px;">付费</span>
                </div>

              </div>
              <div class="video-title" @click="getDetail(item)">{{ item.title }}</div>
            </div>
          </div>
        </van-list>

        <div class="box-tips" v-if="vipInfo.is_vip && params.payed == 1">
          <div class="tips-title">温馨提示</div>
          <div class="tips-txt">
            1.您已购买<span style="color:red;">{{ vipInfo.title }}</span>会员服务
          </div>
          <div class="tips-txt">
            2.截止时间:<span style="color:red;">{{ vipInfo.day }}</span>
          </div>
          <div class="tips-txt">3.请直接点开导航栏目任意视频进行观看</div>
        </div>
        <div class="box-tips" v-if="vipInfo.is_vip == 0 && params.payed == 1 && dataList.length == 0">
          <div class="tips-title">温馨提示</div>

          <div class="tips-txt">您还没有购买记录，请到导航栏目点开视频列表进行选购.</div>
        </div>

      </div>

      <div class="list" :style="{ paddingTop: headerHeight + 'px' }" v-show="step == 3">

        <van-list v-model="loading" :immediate-check="true" loading-text="加载中..." :finished="finished"
          finished-text="没有更多了" @load="doGetPayList" offset="200" direction="down">

          <div class="list-box">
            <div class="list-item" v-for="(item, index) in payDataList" :key="index"
              style="padding-bottom:10px;position: relative;">
              <!-- <div class="shibie-code" @click="showCodeBoxCard(item.code,item.sharecode)">识别码</div> -->
              <img v-if="item.is_collect == 0 && params.today != 1" class="heart" src="../assets/heart1.png" alt=""
                @click="collect(item.id, index)" />
              <img v-if="item.is_collect == 1 && params.today != 1" class="heart" src="../assets/heart2.png" alt=""
                @click="resetCollectC(item.id, index)" />
              <div class="img-wrap" @click="getDetail(item)">
                <div v-if="item.thumb_image" class="thumb">
                  <span class="times" v-if="item.times">时长:{{ item.times }}</span>
                  <span class="today" v-if="params.today == 1">{{ item.day }}</span>

                  <!-- <img :id="item.number+'_img'" src="" width="100%" @error="resetImgUrl(item.number+'_img',item.thumb_image)" /> -->
                  <img :id="item.number + '_img'" src="" width="100%" v-if="item.is_new == 0" />
                  <img :id="item.number + '_img'" :src="item.thumb_image" width="100%" v-if="item.is_new == 1" />
                </div>
                <div class="img-tips-left" style="background: none;padding:0;">
                  <span
                    style="background: #000;opacity: 0.65;padding: 2px 5px;border-radius: 5px;">已有{{ item.rand }}人看过</span>
                </div>
              </div>
              <div class="video-title" @click="getDetail(item)">{{ item.title }}</div>
            </div>
          </div>
        </van-list>

        <div class="box-tips" v-if="vipInfo.is_vip && params.payed == 1" style="margin-bottom: 60px;margin-top: 0;">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div class="tips-title" style="margin: 0;">温馨提示</div>
            <div class="searcn-new" style="margin: 0;padding:0 28px;" @click="webspread">账号中心 </div>
          </div>
          <div class="tips-txt" style="color:red;font-weight: 600;">*您已购买成功，为保障您的权益，需去账号中心注册免费账号才能观看</div>
          <div class="tips-txt">
            1.您已购买<span style="color:red;">{{ vipInfo.title }}</span>会员服务
          </div>
          <div class="tips-txt">
            2.截止时间:<span style="color:red;">{{ vipInfo.day }}</span>
          </div>
          <div class="tips-txt">3.请直接点开导航栏目任意视频进行观看,单片会员请在已购栏目选择对应内容观看。</div>
        </div>
        <div class="box-tips" v-if="vipInfo.is_vip == 0 && params.payed == 1 && payDataList.length == 0">
          <div class="tips-title">温馨提示</div>

          <div class="tips-txt">您还没有购买记录，请到导航栏目点开视频列表进行选购.</div>
          <div class="tips-txt" style="color:red;font-weight: 600;"> *点击上方账号中心,登录后观看已购服务内容*</div>
          <div class="searcn-new" @click="webspread">账号中心 </div>
        </div>

      </div>

      <div class="list" :style="{ paddingTop: headerHeight + 'px' }" v-show="step == 4">
        <van-list v-model="loading" :immediate-check="true" loading-text="加载中..." :finished="finished"
          finished-text="没有更多了" @load="doGetShoucangList" offset="200" direction="down">
          <div class="list-box">
            <div class="list-item" v-for="(item, index) in collectList" :key="index"
              style="padding-bottom:10px;position: relative;">

              <img v-if="item.is_collect == 0 && params.today != 1" class="heart" src="../assets/heart1.png" alt=""
                @click="collect(item.id, index)" />
              <img v-if="item.is_collect == 1 && params.today != 1" class="heart" src="../assets/heart2.png" alt=""
                @click="resetCollect1(item.id, index)" />
              <div class="img-wrap" @click="getDetail(item)">
                <div v-if="item.thumb_image" class="thumb">
                  <span class="times" v-if="item.times">时长:{{ item.times }}</span>
                  <span class="today" v-if="params.today == 1">{{ item.day }}</span>

                  <!-- <img :id="item.number+'_img'" src="" width="100%" @error="resetImgUrl(item.number+'_img',item.thumb_image)" /> -->
                  <img :id="item.number + '_img'" src="" width="100%" v-if="item.is_new == 0" />
                  <img :id="item.number + '_img'" :src="item.thumb_image" width="100%" v-if="item.is_new == 1" />
                </div>
                <div class="img-tips-left" style="background: none;padding:0;">
                  <span
                    style="background: #000;opacity: 0.65;padding: 2px 5px;border-radius: 5px;">已有{{ item.rand }}人看过</span>
                </div>
              </div>
              <div class="video-title" @click="getDetail(item)">{{ item.title }}</div>
            </div>
          </div>
        </van-list>
      </div>
      <!-- 列表数据-->
    </div>

    <!-- 视频详情-->
    <div v-show="step == 2">
      <div class="box body channelbox">
        <div id="msed" style="height: 200px;width: 750px;"> </div>
        <div class="player_bot">
          <div>
            <img
              src="data:image/png;base64,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"
              alt="">
            <p style="font-size: 14px;">支持点赞</p>
          </div>
          <div id="playId">
            <img
              src="data:image/png;base64,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"
              alt="">
            <p style="font-size: 14px;">已购视频</p>
          </div>
          <div @click="showShoucang = true">
            <img
              src="data:image/png;base64,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"
              alt="">
            <p style="font-size: 14px;">
              收藏视频
            </p>
          </div>
        </div>
        <div class="details" style="width: 100%;padding-top:5px;padding-bottom:15px;border-bottom: 1px solid #f2f2f2;">
          <p style="padding: 5px 10px 5px 10px;">
            <span> {{ linkInfo.title }}</span>
          </p>
          <p style="padding: 5px 10px 5px 10px;font-size: 12px;color: #9c9c9c;">
            <span style="padding-right:10px;font-size: 14px;">{{ play_count }}(播放)</span>
            <span style="padding-right:10px;font-size: 14px;">{{ icon_count }}(金币)</span>
            <span style="padding-right:10px;font-size: 14px;">{{ pay_count }}(次打赏)</span>
            <span style="font-size: 14px;">{{ link_count }}(喜欢)</span>
          </p>
        </div>
        <div class="weui-panel__hd" style="text-align: center;font-size: 14px;">精彩视频推荐</div>
        <div class="list" v-if="detailDataList.length > 0">
          <van-list v-model="loading" :immediate-check="true" loading-text="加载中..." :finished="finished"
            finished-text="没有更多了" @load="getVideoList(1, '')" offset="200" direction="down">
            <div class="list-box">
              <div class="list-item" v-for="(item, index) in detailDataList" :key="index" @click="getDetail(item)"
                style="padding-bottom:8px;">
                <div class="img-wrap">
                  <div v-if="item.thumb_image" class="thumb">
                    <span class="times" v-if="item.times">时长:{{ item.times }}</span>

                    <img :id="item.number + '_img'" src="" width="100%" v-if="item.is_new == 0" />
                    <img :id="item.number + '_img'" :src="item.thumb_image" width="100%" v-if="item.is_new == 1" />
                  </div>

                  <div class="img-tips-left" style="background: none;padding:0;">
                    <span
                      style="background: #000;opacity: 0.65;padding: 2px 5px;border-radius: 5px;">已有{{ item.rand }}人看过</span>
                  </div>
                </div>
                <div class="video-title">{{ item.title }}</div>
              </div>
            </div>
          </van-list>
        </div>

      </div>
    </div>
    <!-- 视频详情-->

    <!-- 侧边按钮-->
    <div class="cebian" v-if="step == 1">
      <!-- <div class="today" :style="{ marginRight: marginValue }" @click="getVideoList(88,'cate')">今日上架</div> -->
      <div class="today" :style="{ marginRight: marginValue }" @click="getVideoList(88, 'cate')">今日上架</div>
    </div>
    <!-- <div class="cebian" v-if="step==3 ">
      <div class="ce-shesu" @click="findBox=true">找回</div>
    </div> -->

    <div class="user-box" v-if="step == 5">
      <div class="user-box-title">速娱用户中心</div>
      <div class="user-detail-box">
        <div class="user-avatar">
          <img class="avarimg"
            src="data:image/jpeg;base64,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"
            width="100%" />
        </div>
        <div class="user-info">
          <div class="user-card">
            <div class="user-name">账号:{{ userInfo.username || '未登录' }}</div>
            <div class="user-vip">{{ vipInfo.title || '非会员' }}</div>
          </div>
          <!-- <div class="user-phone">手机号:{{userInfo.mobile}}</div>  -->
          <div class="user-time"> 会员有效期:{{ vipInfo.day || '非会员' }} </div>
          <div class="user-vip" style="font-size: 14px;background: #000;color:#fff;padding:0 15px;border-radius: 20px;">
            免费积分:{{ score || 0 }} </div>
        </div>
      </div>

      <div class="box-tips" v-if="!userInfo.username || !vipInfo.is_vip">
        <div class="tips-title">温馨提示</div>
        <div class="tips-txt">您还没有购买记录，请到导航栏目点开视频列表进行选购.</div>
        <div class="tips-txt">为防止您的购买的资源丢失,请点击下方按钮注册账号.</div>

      </div>

      <div class="box-tips" v-if="vipInfo.is_vip && userInfo.id">
        <div class="tips-title">温馨提示</div>
        <div class="tips-txt">
          1.您已购买<span style="color:red;">{{ vipInfo.title }}</span>会员服务
        </div>
        <div class="tips-txt">
          2.截止时间:<span style="color:red;">{{ vipInfo.day }}</span>
        </div>
        <div class="tips-txt">3.请直接点开导航栏目任意视频进行观看,单片会员请在已购栏目选择对应内容观看。</div>
      </div>
        <div class="tips-btn" @click="showLogin(1)" v-if="!userInfo.id"> 注册</div>
      <div class="remind-box-title" v-if="!userInfo.id" style="width: 380px;height: 45px;line-height: 45px;margin: 20px auto;"
        @click="showLogin(2)"> 登录</div>
        <div class="remind-box-title" v-if="userInfo.id" style="width: 380px;height: 45px;line-height: 45px;margin: 20px auto;"
        @click="goPay"> 点击去观看</div>
        <div class="tips-btn" style="max-width: 280px;" @click="loginOut" v-if="userInfo.id"> 退出登录</div>
    </div>
    <!-- 侧边按钮-->
    <!-- 底部按钮-->

  <!-- <div class="footer-box" >
          <div class="foot-item foot-active" @click="goHot">  热门</div>
          <div class="foot-item foot-active" @click="huanyihuan">换一批</div>
          <div class="foot-item foot-active" @click="shoucang">收藏</div>
          <div class="foot-item foot-active" @click="diushi">防丢失</div>
          <div class="foot-item foot-active" @click="goPay">已付款</div>    
      </div> -->

    <div class="footer-box">
      <div class="foot-item foot-active" @click="goHot"><img style="width: 22px;" src="../assets/fa1.png" />热门推荐</div>
      <div class="foot-item foot-active" @click="huanyihuan"><img style="width: 22px;" src="../assets/fa2.png" />换一批</div>
      <div class="foot-item foot-active" @click="goPay" style="color:#FCB138 !important;"><img style="width: 22px;"
          src="../assets/fa3.png" />已购买</div>
      <div class="foot-item foot-active" @click="shoucang"><i class="fa fa-heart"></i>已收藏</div>


    </div>
  </div>
    <!-- 底部按钮-->

    <div class="share-content" v-if="!showContent">
      <!-- <div class="share-item"></div> -->
      <div class="card">
          <h2 class="card-title">分享到任意<span style="color:red;font-size: 1.4em;">微信群</span>,才可以<span style="color:red;font-size: 1.4em;">继续观看</span></h2>
      </div>
    </div>

    <!-- 详情弹窗-->
    <van-dialog class="demo-dialog van-dialog detail-box" v-model="payBoxModal" :before-close="closeDig"
      :showConfirmButton="false" :showCancelButton="false" :closeOnClickOverlay="true">
      <div class="ds_tankuang" v-if="detail.try_see == 0">
        <img class="ds_poster" v-if="detail.is_new == 0" :id="detail.number + '_ds_poster'" src="" width="100%"
          @error="resetImgUrl(detail.number + '_ds_poster', detail.thumb_image)" />
        <img class="ds_poster" v-if="detail.is_new == 1" :src="detail.thumb_image" width="100%" />
      </div>
      <div id="try_mse" style="width:100%;" v-else>
        <video style="width: 100%;height: 100%;object-fit: fill" ref="videoPlayer" controls controlslist="nodownload"
          @dblclick="toggleFullScreen"></video>
      </div>
      <div class="ds_title">{{ detail.title }}</div>

      <div class="pay-title" style="color:#fff;">付费即可观看完整视频</div>
      <div class="pay-btn-box">
        <van-button square v-for="(item, index) in payBtnList" :key="index" class="index-pay-item" @click="linkTo(item)">
          <div style="display: flex;flex-direction: column;">
            <span>{{ item.name }}</span>

            <span v-if="item.is_desc" style="color:red;font-size: 12px;margin: 5px 0;">{{ item.desc }}</span>
          </div>
        </van-button>
      </div>
      <div class="pay-close-btn" @click="closeDigNew">取消</div>
      <div class="box-remark">
        注:因网络原因，付款成功后不能自动跳转播放，可以重新进入到<span style="color:red;font-size: 13px;">已购</span>列表查看(不换网络不丢单)
      </div>
    </van-dialog>
    <!-- 详情弹窗-->

    <!-- 支付弹窗-->

    <van-action-sheet v-model="payModal" title="选择支付方式">
      <div class="pay-card">
        <div class="pay-tips">注意:付款完成后请返回已购观看</div>
        <div class="pay-tips">注意:支付1失败时请更换支付2</div>
        <div class="pay-list" style="">

          <div class="pay-item" v-for="(item, index) in payList" :key="index" @click="goPayOrder(item.id)"
            style="display: flex;flex-direction: column;">
            <div style="background: #fff;border-radius: 6px;display: flex;">
              <div style="width: 160px; height: 56px;display: flex;justify-content: center;align-items: center;"
                v-if="item.pay_channel == 'alipay'">
                <img class="picon" style="width: 120px;height: 46px;"
                  src="data:image/png;base64,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"
                  v-if="item.pay_channel == 'alipay'">
              </div>
              <div style="width: 160px; height: 56px;display: flex;justify-content: center;align-items: center;"
                v-if="item.pay_channel == 'wxpay'">
                <img class="picon" style="width: 120px;height: 46px;"
                  src="data:image/png;base64,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">
              </div>
            </div>

            <div class="pay-name"
              style="display: flex;flex-direction: column;align-items: center;width: 100%;margin: 8px 0;">
              <!-- <span v-if="item.pay_channel=='alipay'" class="txt">支付宝</span>
                  <span v-if="item.pay_channel=='wxpay'" class="txt">微信</span> -->
              <span class="txt">通道{{ index + 1 }}</span>
            </div>

          </div>


        </div>

      </div>
    </van-action-sheet>
    <!-- 支付弹窗-->

    <!-- 海报弹窗-->
    <!-- <van-dialog class="demo-dialog van-dialog detail-box" v-model="showPosterBox"  :style="{ height: '90%' }"   :showConfirmButton="false"  :showCancelButton="true" :closeOnClickOverlay="true">
      <Poster  :params="params" @save-close="closePoster"></Poster>
    </van-dialog> -->
    <!-- 海报弹窗-->

    <!-- 弹窗提醒-->
    <van-popup v-model="showRemindBox" closeable round close-icon-position="top-right" popup-background-color="#1F2229"
      position="bottom" :style="{ height: '60%' }">

      <div class="remind-box">
        <div class="remind-box-title"> 收藏站点 永不迷路</div>
        <div class="remind-title-tips">{{ shareDataInfo.tip_content }}</div>
        <div class="remind-box-tip1">浏览器永久网址</div>
        <div > 
          <div class="remind-box-link" v-for="(item,index) in shareDataInfo.show_tip_urlList" :key="index">
            <div class="box-link">{{ item }}</div>
            <div class="box-copy" @click="handelClickCopy(item)">复制</div>
          </div>
        </div>
        <div class="remind-box-tip1" style="margin-bottom: 10px;color:red;">重要通知</div>
        <div class="remind-box-tip2"  v-html="shareDataInfo.tip_html">
          
        </div>
      </div>


    </van-popup>
    <!-- 弹窗提醒-->
    <!-- 识别码弹窗-->
    <van-popup v-model="codeBox" round overlay-class="code-box-back">
      <div class="code-box-card">
        <h3 class="code-box-title">保存购买记录</h3>
        <div class="code-content">
          <p class="code-txt">识别码</p>
          <div class="code-txt1">{{ shibieCode }}</div>

        </div>
        <div class="code-txt1" style="margin: 0 10px 20px 10px;color:#614385;font-weight: 600;">永久链接:{{ shareAgentCode }}
        </div>
        <div class="code-tips">
          请妥善保管此识别码，用于后续查询订单信息。
        </div>
        <div style="">
          <div class="code-btn btn-grad" @click="codeBox = false">请手动截图保存</div>
        </div>

      </div>
    </van-popup>
    <!-- 识别码弹窗-->
    <!-- 找回-->
    <van-popup v-model="findBox" round closeable>
      <div class="code-box-card">
        <h3 class="code-box-title">找回购买记录</h3>
        <div class="code-content">
          <p class="code-txt">识别码</p>
          <input class="code-input" v-model="video_code" placeholder="请输入识别码" />
        </div>
        <div class="code-tips">
          请填写您购买时保存的识别码
        </div>
        <div style="">
          <div class="code-btn btn-grad1" @click="findCodeLog">立即找回</div>
        </div>

      </div>
    </van-popup>
    <!-- 找回-->

    <!-- 注册登录-->
    <van-popup v-model="registerBox" close-icon-position="top-right" popup-background-color="#1F2229" position="bottom"
      :style="{ height: loginHeight }" round closeable>
      <div class="remind-box login-box">
        <div class="remind-box-title"> 绑定账号 防丢失会员</div>
        <div class="login-box-title" v-if="loginType == 1"> 注册</div>
        <div class="login-box-title" v-else> 登录</div>
        <div class="login-form">
          <div class="login-form-item">
            <label class="login-label">登录账号</label>
            <input type="text" class="login-input" v-model="username" placeholder="请输入登录账号">
          </div>
          <div class="login-form-item">
            <label class="login-label">登录密码</label>
            <input type="password" class="login-input" v-model="password" placeholder="请输入登录密码">
          </div>
          <div class="login-form-item" v-if="loginType == 1">
            <label class="login-label">确认密码</label>
            <input type="password" class="login-input" v-model="password1" placeholder="请确认登录密码">
          </div>
        </div>
        <div class="login-btn" v-if="loginType == 1" @click="loginReg"> 注册</div>
        <div class="login-btn" v-else @click="loginReg"> 登录</div>

      </div>
    </van-popup>
    <!-- 注册登录-->

    <!-- 海报弹窗-->
    <van-dialog class="demo-dialog van-dialog detail-box" v-model="showPosterBox" :style="{ height: '540px' }"
      :showConfirmButton="false" :showCancelButton="false" :closeOnClickOverlay="true">
      <Sposter :params="params" @save-close="closePoster"></Sposter>
    </van-dialog>
    <!-- 海报弹窗-->
    <!--选择弹窗 #292e32-->
      <van-popup v-model="chooseBox"  round closeable>
          <div class="choose-box">
            <div class="choose-pay" @click="chooseBoxPay(1)"> 付费直接看</div>
            <div class="choose-share" @click="chooseBoxPay(2)"> 分享免费看</div>
          </div>
      </van-popup>
      <!-- 选择弹窗 -->

      <!--选择弹窗 #292e32-->
      <van-popup v-model="showShareTipsBox"  round  overlay-class="show-share-tips" >
          <div class="show-share-tips-box">
            <div class="blur-bg"></div>
            <div style="font-size: 18px;font-weight: 600;">需要分享后才能继续观看</div>
            <h1 style="font-size: 20px;color:red;">请分享后</h1>
            <div style="font-size: 16px;">即可继续观看</div>
            <div style="display: flex;justify-content: space-around;width: 100%;"> 
              <div class="share-btn-cl" @click="resetShare" style="background: #3d3a4e;"> 返回首页</div>
              <div class="share-btn-cl" @click="startShare"> 确定分享</div>
            </div>
          </div>
      </van-popup>
      <!-- 选择弹窗 -->
  </div>
  
 
</template>
<script>
import { nc6Api, pvv6Api, iv6Api, vv6Api, cov6Api, vlv6Api, colv6Api, delv6Api, pav7Api, plyv6Api, collv6Api, dv6Api, gvcodApi, loginApi, userApi ,getScoreApi} from "@/api/api";
import { imageLoader } from './image-loader';
import Poster from '@/components/poster.vue';
import Sposter from '@/components/sposter.vue';
import QRCode from "qrcode";
import axios from 'axios';
import { imageUrlToBase64 } from '@/utils/imageUtils';
import CryptoJS from 'crypto-js';
import storage from '@/utils/storage';
import { LevelKey } from 'hls.js';
import bplayer from '@/utils/bplayer';
//import Player from 'xgplayer';
export default {
  components: {
    Poster,
    Sposter
  },
  data() {
    return {
      showShouCang:true,
      showShareTipsBox:false,
      chooseBox:false,
      registerBox: false,
      findBox: false,
      codeBox: false,
      showRemindBox: false,
      showPosterBox: false,
      payModal: false,
      payBoxModal: false,
      headerHeight: 0,
      categoryList: [],
      step: 1,
      cate_id: 0,
      loading: false,
      finished: false,
      params: {
        cate_id: 0,
        key: '',
        ldk: '',
        payed: '',
        uid: '',
        page: 1,
        limit: 10,
        templete_id: 1,
        webmanage: 0,
      },
      dataList: [],
      detailDataList: [],
      collectList: [],
      payDataList: [],
      remark: '',
      transction_id: '',
      ds_try_see: 0,
      detail: {
        try_see: 0,
        thumb_image: '',
        title: '',
        id: 0
      },
      payBtnList: [],
      jiekou: '',
      pay_id: 1,
      shebei_type: '',
      inidData: [],
      payList: [],
      goodsInfo: '',
      styleLink: null,
      vipInfo: {
        title: '',
        day: '',
        is_vip: 0,
        score: 0
      },
      myKey: '',
      showContent: false,
      try_player: '',
      videoLink: '',
      showVideo: true, // 新增控制变量
      lastScrollTop: 0,  // 记录上次滚动位置
      scrollTimer: null,
      itemsPerRow: 7,
      isFixed: true,
      placeholderHeight: 0,
      scrollThreshold: 300, // 滚动阈值
      marginValue: '10px',
      linkInfo: {},
      seed: 1,
      play_count: Math.floor(Math.random() * 10001),
      icon_count: '',
      pay_count: '',
      link_count: '',
      vid: '',
      fav: '',
      try_pay_player: '',
      shareDataInfo: {
        tip_content: '',
        tip_image: '',
        tip_url: '',
        show_tip_url:'  ',
        show_tip_urlList:[],
        tip_html:''

      },
      qrCodeData: '',
      shibieCode: '******',
      video_code: '',
      shareAgentCode: '',
      userInfo: [],
      username: '',
      password: '',
      loginType: 1,
      loginHeight: '70%',
      password1: '',
      fullText: "点击收藏",
      typedText: "",
      charIndex: 0,
      score: 0
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.debouncedScroll, true);
  },
  watch: {
    showVideo: {
      handler(newVal) {
        this.$nextTick(() => {
          this.updateHeaderHeight();
        });
      }
    },
    categoryList: {
      handler() {
        this.$nextTick(() => {
          this.updateHeaderHeight();
        });
      }
    }
  },
  computed: {
    groupedCategories() {
      const result = [];
      for (let i = 0; i < this.categoryList.length; i += this.itemsPerRow) {
        result.push(this.categoryList.slice(i, i + this.itemsPerRow));
      }
      return result;
    }
  },
  beforeCreate() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 1000
    });

  },
  created() {

    let that = this;
    // 添加滚动监听
    this.initScrollListener();
    window.addEventListener('resize', this.updateHeaderHeight);

    that.showContent = true;
    //that.getLocalUid();
    //初始化数据
    that.setInitData();
    //获取设备类型
    that.shebei_type = that.getDeviceType();
    //初始化
    that.getInitData();
    //获取分类列表
    that.getCategoryList();
    //获取登录用户信息
    that.getUserInfo();
    //获取视频列表
    let cate = this.$route.query.cate;
    if (cate == 'payed') {
      that.getVideoList(99, 'payed');
    } else {
      that.getVideoList(0, '');
    }
    if (this.$route.query.cate_id) {
      this.cate_id = this.$route.query.cate_id;
      this.chooseCate(this.cate_id);
    }
    //获取订单数据
    that.getOrderData();
    this.startTyping();

  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.updateHeaderHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateHeaderHeight);
  },
  methods: {
    startShare(){
        this.showPosterBox=true;
      },
      resetShare(){
        this.showShareTipsBox=false;
        this.showContent=true;
        this.goHot();
      },
    startTyping() {
      setInterval(() => {
        if (this.charIndex < this.fullText.length) {
          this.typedText += this.fullText[this.charIndex];
          this.charIndex++;
        } else {
          this.typedText = "";
          this.charIndex = 0;
        }
      }, 300); // 每300ms显示一个字，可调节速度
    },
    showLogin(type) {
      if (type == 1) {
        this.registerBox = true
        this.loginType = 1;
        this.loginHeight = '70%'
      } else {
        this.registerBox = true
        this.loginType = 2
        this.loginHeight = '60%'
      }
    },
    loginOut(){
      window.localStorage.removeItem('token');
            window.localStorage.removeItem('userid');
            window.localStorage.removeItem('userInfo');
            this.getUserInfo();
    },
    getUserInfo() {
      let that = this;
      let token = window.localStorage.getItem('token');
      if (!token) {
        that.userInfo = { username: '', id: '', token: '' };
      } else {
        //that.userInfo=JSON.parse(userInfo);
        //验证token是否过期
       userApi({}).then(res => {
          let temp = JSON.parse(that.$decryptData(res));
          if (temp.is_login != 1) {
            window.localStorage.removeItem('token');
            window.localStorage.removeItem('userid');
            window.localStorage.removeItem('userInfo');
          } else {
            if(temp.user){
              that.userInfo =temp.user;
              window.localStorage.setItem('token', temp.user.token);
              window.localStorage.setItem('userid', temp.user.id);
              window.localStorage.setItem('userInfo', JSON.stringify(temp.user));
            }
            
          }
        });
      }
    },
    loginReg() {
      let that = this;
      if (!that.username) {
        that.$toast('请输入用户名');
        return;
      }
      if (!that.password) {
        that.$toast('请输入用户名');
        return;
      }
      if (that.loginType == 1 && that.password != that.password1) {
        that.$toast('两次密码不一致');
        return;
      }
      loginApi({ username: that.username, password: that.password, loginType: that.loginType }).then(res => {
        that.$toast(res.msg);
        if (res.code == 1) {
          window.localStorage.setItem('token', res.data.token);
          window.localStorage.setItem('userid', res.data.id);
          window.localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.userInfo = res.data;
          that.registerBox = false;
          //that.loginType=2;
        }
      })
    },
    findCodeLog() {
      let that = this;
      if (!that.video_code) {
        that.$toast('请填写识别码');
        return;
      }
      gvcodApi({ code: that.video_code, ldk: that.params.ldk }).then(res => {
        let temp = JSON.parse(that.$decryptData(res));
        that.$toast(temp.msg);
        if (temp.code == 1) {
          that.findBox = false;
          that.video_code = '';
          that.goPay();
        }
      });
    },
    showCodeBoxCard(code, agentcode) {
      this.shibieCode = code;
      this.shareAgentCode = agentcode;
      this.codeBox = true;
    },
    async generateQRCode(url) {
      let that = this;
      try {
        const qrCodeDataURL = await QRCode.toDataURL(url, {
          width: 150,
          margin: 1,
        });
        that.qrCodeData = qrCodeDataURL;

      } catch (err) {
        console.error("二维码生成失败:", err);
      }
    },
    handelClickCopy(text) {
      this.$copyText(text).then(e => {
        this.$toast('复制成功');
      }).catch(e => {
        this.$toast('复制失败');
      })
    },
    doGetPayList() {

      this.getPayVideoList(1, 'payed');
    },
    doGetShoucangList() {
      this.getCollectList();
    },
    closePoster() {
      this.showPosterBox = false;
    },
    collect(video_id, index) {
      let that = this;
      let data = {
        video_id: video_id,
        uid: that.params.uid,
        ldk: that.params.ldk
      }
      data.sp = window.localStorage.getItem('sp');
      data.ua = window.localStorage.getItem('parent');
      colv6Api(data).then(res => {
        let temp = JSON.parse(that.$decryptData(res));
        if (temp.code == 1) {
          that.dataList[index].is_collect = 1;

        }
      })
    },
    resetCollect(video_id, index) {
      let that = this;
      let data = {
        video_id: video_id,
        uid: that.params.uid,
        ldk: that.params.ldk
      }
      data.sp = window.localStorage.getItem('sp');
      data.ua = window.localStorage.getItem('parent');
      delv6Api(data).then(res => {
        let temp = JSON.parse(that.$decryptData(res));
        if (temp.code == 1) {
          that.dataList[index].is_collect = 0;

        }
      })
    },
    resetCollect1(video_id, index) {
      let that = this;
      let data = {
        video_id: video_id,
        uid: that.params.uid,
        ldk: that.params.ldk,

      }
      data.sp = window.localStorage.getItem('sp');
      data.ua = window.localStorage.getItem('parent');
      delv6Api(data).then(res => {
        let temp = JSON.parse(that.$decryptData(res));
        if (temp.code == 1) {
          that.dataList[index].is_collect = 0;
          that.params.page = 1;
          that.dataList = [];
          that.shoucang();
        }
      })
    },
    preView(blob, element) {
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
        const imgElement = document.getElementById(element);
        if (imgElement) {
          imgElement.src = e.target.result;
        }
      };
    },
    jsReadFiles(blob, element) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onload = function () {
        // 转换为 Blob 并显示图片
        var result = new Blob([reader.result.slice(3)], { type: 'image/jpeg' });
        this.preView(result, element); // 显示图片
      }.bind(this);  // 确保 this 指向正确
    },
    resetImgUrl(imageobj, url) {
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.open("GET", url + '_.pdf', true);
      xmlhttp.responseType = "blob";
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === XMLHttpRequest.DONE) {
          if (xmlhttp.status === 200) {
            this.jsReadFiles(xmlhttp.response, imageobj); // 处理图片显示
          } else {
            // 处理请求错误或返回空图片
            console.error("Failed to load image", url);
          }
        }
      }.bind(this);  // 确保 this 指向正确
      xmlhttp.send(null);
    },

    goIndex() {
      this.$router.push({ path: '/', query: { ldk: this.params.ldk, uid: this.params.uid } });
    },
    goPay() {
      //this.$router.push({path:'/pay',query:{ldk:this.params.ldk,uid:this.params.uid,cate:'payed'}});
      this.step = 3;
      this.loading = true;
      this.showVideo = false;
      this.payDataList = [];
      this.finished = false;
      this.params.page = 1;
      this.params.payed = 1;
      this.getPayVideoList('payed', '');
      this.getVipInfo();
    },
    updateHeaderHeight() {
      const headerBox = this.$refs.headerBox;
      let num = 0;
      if (this.showVideo && this.videoLink) {
        num = 150;
      }
      if (headerBox) {
        this.headerHeight = headerBox.offsetHeight + num;
      }
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.scrollThreshold) {
        if (!this.isFixed) {
          this.isFixed = true;
          this.updateHeaderHeight();
        }
      } else if (scrollTop === 0 || scrollTop > 150) {
        this.isFixed = true;
        this.placeholderHeight = 0;
        this.showVideo = false;
        if (this.try_player) {
          this.try_player.destroy();
          this.try_player = '';
        }
        this.videoLink = '';
        this.$nextTick(() => {
          this.updateHeaderHeight();
        });
      }
    },
    initScrollListener() {
      window.addEventListener('scroll', this.handleScroll, {
        passive: true // 提高滚动性能
      });
    },
    createPlayer(videoInfo = null) {
      if (this.try_player) {
        this.try_player.destroy();
        this.try_player = '';
      }
      let self = this;
      this.$nextTick(() => {
        if (videoInfo) {


          self.try_player = new Player({
            "id": 'msed',
            "url": videoInfo.link,
            "playsinline": true,
            "poster": videoInfo.thumb_image,
            "x5-video-player-fullscreen": true,
            "x5-video-orientation": "portraint",
            "x5-video-player-type": "h5-page",
            "fluid": true,
            closeVideoClick: true,
            closeVideoDblclick: true,
            closeVideoTouch: true,
            closePlayerBlur: true,
            closeControlsBlur: true,
            closeFocusVideoFocus: true,
            closePlayVideoFocus: true,
            enableContextmenu: true
          });
          self.try_player.start();
        } else {


          self.try_player = new Player({
            "id": 'spreadmsed',
            "url": self.videoLink,
            "playsinline": true,
            "poster": '',
            "x5-video-player-fullscreen": "false",
            "x5-video-orientation": "portraint",
            "x5-video-player-type": "h5-page",
            "fluid": true,
            closeVideoClick: true,
            closeVideoDblclick: true,
            closeVideoTouch: true,
            closePlayerBlur: true,
            closeControlsBlur: true,
            closeFocusVideoFocus: true,
            closePlayVideoFocus: true,
            enableContextmenu: true
          });

          self.try_player.start();
        }
      });


    },
    createDetailPlayer(videoInfo) {
      let that = this;
      if (that.try_pay_player) {

        that.try_pay_player.pause();
        that.try_pay_player.destroy();
        that.try_pay_player = '';
      }

      that.$nextTick(() => {
        that.try_pay_player = new Player({
          "id": 'msed',
          "url": videoInfo.link,
          "playsinline": true,
          // "poster": videoInfo.thumb_image,
          "x5-video-player-fullscreen": "false",
          "x5-video-orientation": "portraint",
          "x5-video-player-type": "h5",
          "fluid": true,
          closeVideoClick: true,
          closeVideoDblclick: true,
          closeVideoTouch: true,
          closePlayerBlur: true,
          closeControlsBlur: true,
          closeFocusVideoFocus: true,
          closePlayVideoFocus: true,
          enableContextmenu: true

        });
        // 禁止点击事件触发播放/暂停
        const playerElement = document.getElementById('msed');
        playerElement.addEventListener('click', (e) => {
          e.stopPropagation();  // 阻止点击事件冒泡
        });

        // 禁止触摸事件触发播放/暂停
        playerElement.addEventListener('touchend', (e) => {
          e.stopPropagation();  // 阻止触摸事件冒泡
        });


        that.try_pay_player.start();
      });

    },
    getOrderData() {
      let that = this;
      let ldk = this.$route.query.ldk;
      let ordno = this.$route.query.ordno;
      if (ldk) {
        that.params.ldk = ldk;
        window.localStorage.setItem('ldk', ldk);
      }
      //通过订单号获取订单信息
      if (ordno) {
        cov6Api({ ordno: ordno }).then(res => {
          let temp = JSON.parse(that.$decryptData(res));
          if (temp.code == 1 && temp.msg == 'success') {
            localStorage.setItem('sp', temp.data.ip);
            localStorage.setItem('parent', temp.data.ua);
           
            that.step = 2;
            that.linkInfo = temp.data.video;
            that.createDetailPlayer(temp.data.video);

            that.dataList = [];
            that.detailDataList = [];
            that.finished = false;
            that.params.page = 1;
            that.params.payed = 0;
            that.params.cate_id = 0;
            that.getVideoList(-1, '');

          }
        });
      }
    },
    setInitData() {
      let templete_id = this.getURLParameter('kt');
      if (!templete_id || templete_id == 'undefined') {
        let old_tem = window.localStorage.getItem('templete_id');
        if (old_tem && old_tem == 'undefined') {
          templete_id = old_tem;
        } else {
          templete_id = 1;
        }
      }

      this.params.templete_id = templete_id;
      window.localStorage.setItem('templete_id', templete_id);
      this.params.ldk = this.getURLParameter('ldk');
      this.params.uid = this.getURLParameter('uid');
      if (!this.params.ldk || this.params.ldk == 'undefined' || this.params.ldk == '') {
        let ldk = this.getKey('ldk');
        if (!ldk) {
          this.params.ldk = window.localStorage.getItem('ldk');
        } else {
          this.params.ldk = ldk;
          window.localStorage.setItem('ldk', ldk);
        }

      }
      if (!this.params.uid || this.params.uid == 'undefined' || this.params.uid == '') {
        this.params.uid = window.localStorage.getItem('visitorId');
      }


    },
    getURLParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    getKey(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.hash);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    searchList() {
      if (!this.params.key) {
        this.$toast('请输入搜索关键词');
        return;
      }
      this.getVideoList(1, 'key');
    },
    getDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        console.log('1');
        return 1;
      }
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        this.marginValue = '30px';
        console.log('2');
        return 2;
      }
      console.log('other device');
      return -1;
    },
    getDetail11(item) {
      this.detail = item;
      if (item.is_new == 0) {
        this.resetImgUrl(item.number + '_ds_poster', item.thumb_image);
      }

      //判断用户是否支付
      if (item.is_pay == 1) {
        let userInfo = window.localStorage.getItem('userInfo');
        if (!userInfo) {
          this.userInfo = { username: '', id: '', token: '' };
          return this.$toast('为保障您的权益,请先去账号中心注册登录账号');
        } else {
          this.userInfo = JSON.parse(userInfo);
          if (this.userInfo.id == '') {
            return this.$toast('为保障您的权益,请先去账号中心注册登录账号');
          }
        }

        //已支付
        //this.$router.push({path:'/detail',query:{vid:item.id,ldk:this.params.ldk,uid:this.params.uid}});
        let beforestep = this.step;
        this.step = 2;

        this.linkInfo = item;
        this.createDetailPlayer(item);
        if (beforestep != this.step) {
          this.dataList = [];
          this.finished = false;
          this.params.page = 1;
          this.params.payed = 0;
          this.params.cate_id = 0;
          this.getVideoList(-1, '');
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });

      } else {
        //未支付
        let datas = {
          ldk: this.params.ldk,
          uid: this.params.uid,
          vid: item.id
        }
        let localPayBtnList = window.localStorage.getItem('localPayBtnList');

        if (localPayBtnList && localPayBtnList != 'undefined' && localPayBtnList != null) {
          let temp = JSON.parse(this.$decryptData(localPayBtnList));
          this.payBtnList = temp;
          this.payBoxModal = true;
        } else {
          pvv6Api(datas).then(res => {
            let temp = JSON.parse(this.$decryptData(res));
            this.payBtnList = temp;
            this.payBoxModal = true;
            window.localStorage.setItem('localPayBtnList', res);
          })
        }


      }
    },
    chooseBoxPay(type){
        const item=this.detail;
        if(type==1){
          this.chooseBox=false;
          if(item.is_new==0){
            this.resetImgUrl(item.number+'_ds_poster',item.thumb_image);
          }
        
          //判断用户是否支付
          if(item.is_pay==1){
            //已支付
            //this.$router.push({path:'/detail',query:{vid:item.id,ldk:this.params.ldk,uid:this.params.uid}});
            let beforestep=this.step;
            this.step=2;

            this.linkInfo=item;
            this.createDetailPlayer(item);
            if(beforestep!=this.step){
              this.dataList = [];
              this.finished = false;
              this.params.page = 1;
              this.params.payed = 0;
              this.params.cate_id = 0;
              this. getVideoList(-1,'');
            }
          
            window.scrollTo({ top: 0, behavior: 'smooth' });

          }else{
            //未支付
            let datas={
                ldk:this.params.ldk,
                uid:this.params.uid,
                vid:item.id
              }
            let localPayBtnList=window.localStorage.getItem('localPayBtnList');
            
            if(localPayBtnList && localPayBtnList!='undefined' && localPayBtnList!=null){
              let temp=JSON.parse(this.$decryptData(localPayBtnList));
              this.payBtnList=temp;
              this.payBoxModal=true;
            }else{
              pvv6Api(datas).then(res=>{
                let temp=JSON.parse(this.$decryptData(res));
                this.payBtnList=temp;
                this.payBoxModal=true;
                window.localStorage.setItem('localPayBtnList',res);
              })
            }
            
          
          }
        }else{
          this.chooseBox=false;
          this.showContent=false;
          this.showShareTipsBox=true;
        }
      },
    getDetail(item){
        //判断用户是否有积分
        
        if(item.is_pay==1){
                this.detail=item;
                if(item.is_new==0){
                  this.resetImgUrl(item.number+'_ds_poster',item.thumb_image);
                }
              
                //判断用户是否支付
                if(item.is_pay==1){
                  //已支付
                  //this.$router.push({path:'/detail',query:{vid:item.id,ldk:this.params.ldk,uid:this.params.uid}});
                  let beforestep=this.step;
                  this.step=2;

                  this.linkInfo=item;
                  this.createDetailPlayer(item);
                  if(beforestep!=this.step){
                    this.dataList = [];
                    this.finished = false;
                    this.params.page = 1;
                    this.params.payed = 0;
                    this.params.cate_id = 0;
                    this. getVideoList(-1,'');
                  }
                
                  window.scrollTo({ top: 0, behavior: 'smooth' });

                }else{
                  //未支付
                  let datas={
                      ldk:this.params.ldk,
                      uid:this.params.uid,
                      vid:item.id
                    }
                  let localPayBtnList=window.localStorage.getItem('localPayBtnList');
                  this.payBoxModal=true;
                  if(localPayBtnList && localPayBtnList!='undefined' && localPayBtnList!=null){
                    let temp=JSON.parse(this.$decryptData(localPayBtnList));
                    this.payBtnList=temp;
                    
                  }else{
                    pvv6Api(datas).then(res=>{
                      let temp=JSON.parse(this.$decryptData(res));
                      this.payBtnList=temp;
                      
                      window.localStorage.setItem('localPayBtnList',res);
                    })
                  }
                  
                
                }

        }else{
          if(item.is_free==1){
            if(this.score>0){
              getScoreApi({vid:item.id,ldk:this.params.ldk}).then(res=>{ 
                let temp=JSON.parse(this.$decryptData(res));
                this.score=temp.score;
                if(temp.is_free==1){
                      let beforestep=this.step;
                      this.step=2;
                      this.linkInfo=item;
                      this.createDetailPlayer(item);
                      if(beforestep!=this.step){
                        this.dataList = [];
                        this.finished = false;
                        this.params.page = 1;
                        this.params.payed = 0;
                        this.params.cate_id = 0;
                        this. getVideoList(-1,'');
                      }
                    
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                }else{
                  this.detail=item;
                  this.chooseBox=true;
                }
                
              })
            }else{
              this.detail=item;
              this.chooseBox=true;
            }
          }else{
             this.detail=item;
             this.payBoxModal=true;
              if(item.is_new==0){
                this.resetImgUrl(item.number+'_ds_poster',item.thumb_image);
              }

               //未支付
                  let datas={
                      ldk:this.params.ldk,
                      uid:this.params.uid,
                      vid:item.id
                    }
                  let localPayBtnList=window.localStorage.getItem('localPayBtnList');
                  
                  if(localPayBtnList && localPayBtnList!='undefined' && localPayBtnList!=null){
                    let temp=JSON.parse(this.$decryptData(localPayBtnList));
                    this.payBtnList=temp;
                    
                  }else{
                    pvv6Api(datas).then(res=>{
                      let temp=JSON.parse(this.$decryptData(res));
                      this.payBtnList=temp;
                     
                      window.localStorage.setItem('localPayBtnList',res);
                    })
                  }
                  

          }

            
        }
         
      },

    setVideoInfo() {
      if (!this.vid) {
        return this.$toast('请选择视频');
      }
      let datas = {
        ldk: this.params.ldk,
        uid: this.params.uid,
        vid: this.vid
      }
      dv6Api(datas).then(res => {
        if (res) {
          let temp = JSON.parse(this.$decryptData(res));

          if (temp.pay != 1) {
            return this.$toast('当前视频未支付');
          }
          this.linkInfo = temp.detail;
          if (this.try_player) {
            this.try_player.destroy();
            this.try_player = '';
          }
          this.createPlayer(temp.detail);
          this.fav = temp.fav;
        }
      });

    },
    dingbu() {

      this.getVideoList(-1, 'cate');
      //location.reload();
      this.showVideo = false;
      this.lastScrollTop = 0;
      this.headerHeight = this.$refs.headerBox.offsetHeight;
    },
    goHot() {
      this.step = 1;
      this.params.today = 0;
      this.dataList = [];
      this.finished = false;
      this.params.page = 1;
      this.params.payed = 0;
      this.params.cate_id = 0;
      this.getVideoList(-1, '');
      this.getInitData();
    },
    huanyihuan(){
      this.step = 1;
      this.params.today = 0;
      this.dataList = [];
      this.finished = false;
      this.params.page = 1;
      this.params.payed = 0;
      this.params.cate_id = 0;
      this.getVideoList(-1, '');
    },
    shoucang() {
      //this.$router.push({path:'/collect',query:{ldk:this.params.ldk,uid:this.params.uid}});
      this.step = 4;
      this.loading = true;
      this.showVideo = false;
      this.collectList = [];
      this.finished = false;
      this.params.page = 1;
      this.params.payed = 0;
      this.getCollectList();
    },
    diushi() {
      this.step = 1;
      this.showPosterBox = true;
      //this.goHot();
    },
    getHeight() {
      //this.headerHeight=190;
      let heigthBox = this.$refs.headerBox.offsetHeight;
      if (heigthBox < 160) {
        //heigthBox=165;
      }
      this.headerHeight = heigthBox;

    },
    getCategoryList() {
      nc6Api({ ldk: this.params.ldk }).then(res => {
        let that = this;
        this.categoryList.push({ id: 0, name: '全部' });
        let list = JSON.parse(that.$decryptData(res));
        list.map(item => {
          that.categoryList.push(item);

        })
      });
    },
    chooseCate(cate_id) {
      this.cate_id = cate_id;
      this.params.cate_id = cate_id;

      this.step = 1;
      this.params.today = 0;
      this.dataList = [];
      this.finished = false;
      this.params.page = 1;
      this.params.payed = 0;
      this.getVideoList(1, 'cate');
    },

     webspread() {
      this.step = 5;
      this.getUserInfo();
      this.params.today=0;
      this.dataList = [];
      this.finished = false;
      this.params.page = 1;
      this.params.payed = 0;
      this.params.webmanage=1;
      this.getVideoList(1,'mannge');
    },

    resetImgUrl2(imageId, url) {
      imageLoader.loadImage(imageId, url);
    },

    // 批量加载图片
    loadImages(dataList) {
      dataList.forEach(item => {
        this.resetImgUrl(item.number + '_img', item.thumb_image);
      });
    },
    doGetList() {
      this.params.page++;
      this.getVideoList(1, '');
    },
    getVideoList(index, type) {
      let that = this;
      if (type == 'cate') {
        that.dataList = [];
        that.finished = false;
        that.params.page = 1;
        that.params.payed = 0;
        that.params.key = '';
        if (index == 88) {
          that.params.today = 1;
          that.params.cate_id = 0;
        } else {
          that.params.today = 0;
        }
        that.params.webmanage = 0;

      }

      if (type == 'mannge') {
        that.dataList = [];
        that.finished = false;
        that.params.page = 1;
        that.params.payed = 0;
        that.params.key = '';
        that.params.today = 0;
        that.params.cate_id = 0;
      }
      that.loading = true;
      if (type == 'key') {
        that.dataList = [];
        that.finished = false;
        that.params.page = 1;
        that.params.payed = 0;
        that.params.webmanage = 0;
      }
      if (type == 'payed') {
        that.showVideo = false;
        that.dataList = [];
        that.finished = false;
        that.params.page = 1;
        that.params.payed = 1;
        that.params.webmanage = 0;
        if (!that.params.uid) {
          that.params.uid = window.localStorage.getItem('visitorId');
        }
      }
      that.params.sp = window.localStorage.getItem('sp');
      that.params.ua = window.localStorage.getItem('parent');
      vlv6Api(that.params).then(res => {
        that.loading = false;

        if (res) {
          //let temp=JSON.parse(that.$Base64.decode(res.data));
          let temp = JSON.parse(that.$decryptData(res));
          if (that.params.page < temp.last_page) {
            let newData = temp.data;
            if (that.step == 2) {
              that.detailDataList = [...that.detailDataList, ...newData]
              newData.map(item => {

                if (item.is_new == 0) {
                  that.resetImgUrl(item.number + '_img', item.thumb_image);
                }

              })
            } else {
              that.dataList = [...that.dataList, ...newData]
              newData.map(item => {

                if (item.is_new == 0) {
                  that.resetImgUrl(item.number + '_img', item.thumb_image);
                }

              })
            }


            // 增加页码
            that.params.page++;

          } else {

            that.params.page = 1;
            if (that.dataList.length > 0) {
              that.getVideoList(index, '');
            } else {
              that.finished = true;
            }

          }
        } else {
          that.loading = false;
          that.finished = true;

          //Toast.fail('加载失败');

        }
      });

    },
    closeDig(action, done) {

      done(); // 关闭提示框
    },
    closeDigNew() {
      this.payBoxModal = false;
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause(); // 停止播放视频
      }
      this.detail = {
        try_see: 0,
        thumb_image: '',
        title: '',
        id: 0
      }

    },
    getInitData() {
      let that = this;
      iv6Api({ ldk: that.params.ldk, payed: that.params.payed, shebei_type: that.shebei_type }).then(res => {
        let temp = JSON.parse(that.$decryptData(res));

        if (temp.agenturl && temp.agenturl != '') {
          window.location.href = temp.agenturl;
        }
        that.initData = temp;
        that.jiekou = temp.jiekou;
        that.payList = temp.payList;
        that.myKey = temp.mykey;
        that.payBtnList = JSON.parse(that.$decryptData(temp.payBtnList));
        that.shareDataInfo.tip_content = temp.tip_content;
        that.shareDataInfo.tip_image = temp.tip_image;
        that.shareDataInfo.tip_url = temp.tip_url;
        that.shareDataInfo.show_tip_url=temp.show_tip_url;
        that.shareDataInfo.show_tip_urlList=temp.show_tip_urlList;
        that.shareDataInfo.tip_html = temp.tip_html;
        that.score = temp.score;
        if (temp.is_index == 1) {
          if (temp.is_poster == 1) {
            that.showPosterBox = true;
          } else {
            that.showRemindBox = true;
            that.generateQRCode(temp.tip_url);
          }
        }
        if(temp.is_shoucang==1){
          that.showShouCang=true;
        }else{
          that.showShouCang=false;
        }
        
        window.localStorage.setItem('localPayBtnList', temp.payBtnList);
        window.localStorage.setItem('jiekou', temp.jiekou);
        window.localStorage.setItem('payList', JSON.stringify(temp.payList));
        window.localStorage.setItem('IP', temp.ip);
        if (temp.videoLink) {
          that.videoLink = temp.videoLink;
          that.createPlayer();
          that.$nextTick(() => {
            that.updateHeaderHeight();
          })
        }

      })
      this.getVipInfo();
    },
    getVipInfo() {
      if (!this.params.uid) {
        this.params.uid = window.localStorage.getItem('visitorId');
      }
      let sp = window.localStorage.getItem('sp');
      let ua = window.localStorage.getItem('parent');
      let that = this;
      vv6Api({ ldk: this.params.ldk, uid: this.params.uid, sp: sp, ua: ua }).then(res => {
        let temp = JSON.parse(that.$decryptData(res));
        this.vipInfo = temp;
      })
    },
    linkTo(item) {
      this.goodsInfo = item;
      this.payModal = true;
    },
    goPayOrder(pay_id) {
      let that = this;
      if (!that.goodsInfo) {
        that.$toast('请选择影视资源类型');
        return;
      }

      let ip = window.localStorage.getItem('IP');

  
      let data = { pay_id: pay_id, ip: ip, uid: that.params.uid, vid: this.detail.id, ldk: this.params.ldk, is_type: this.goodsInfo.is_type };
      pav7Api(data).then(res => {
        let temp = JSON.parse(that.$decryptData(res));
     
        //return;
        if (temp.code == 1) {
          if (temp.data.payurl) {

            window.location.href = temp.data.payurl
          }

        } else {
          that.$toast.fail(temp.msg);
        }
      })
    },
    shensu() {
      this.$router.push({ path: '/shensu', query: { ldk: this.params.ldk, uid: this.params.uid } });
    },

    getPayVideoList(index, type) {

      let that = this;
      that.params.cate_id = 0;
      that.params.sp = window.localStorage.getItem('sp');
      that.params.ua = window.localStorage.getItem('parent');
      plyv6Api(that.params).then(res => {
        that.loading = false;
        this.is_query = 1;
        if (res) {
          let temp = JSON.parse(that.$decryptData(res));

          if (that.params.page <= temp.last_page) {
            let newData = temp.data;
            that.payDataList = [...that.payDataList, ...newData]
            newData.map(item => {
              if (item.is_new == 0) {
                that.resetImgUrl(item.number + '_img', item.thumb_image);
              }

            })

            // 增加页码
            that.params.page++;

          } else {
            that.finished = true;
          }
        } else {
          that.loading = false;
          that.finished = true;

          Toast.fail('加载失败');

        }
      });
    },
    getCollectList() {
      let that = this;

      that.params.cate_id = 0;
      that.params.sp = window.localStorage.getItem('sp');
      that.params.ua = window.localStorage.getItem('parent');
      collv6Api(that.params).then(res => {
        that.loading = false;
        this.is_query = 1;
        if (res) {
          let temp = JSON.parse(that.$decryptData(res));
          if (that.params.page <= temp.last_page) {
            that.params.page++;
            let newData = temp.data;
            that.collectList = [...that.collectList, ...newData]
            newData.map(item => {
              if (item.is_new == 0) {
                that.resetImgUrl(item.number + '_img', item.thumb_image);
              }

            })

          } else {
            that.finished = true;
          }
        } else {
          that.loading = false;
          that.finished = true;

          Toast.fail('加载失败');

        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.code-box-card {
  width: 320px;
  border-radius: 10px;
  min-height: 320px;
  padding: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;

  .code-box-title {
    width: 300px;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
  }

  .code-content {
    background: #f8f8f8;
    margin: 20px 30px;
    padding: 20px;
    border-radius: 15px;
    color: rgb(107 114 128);
    width: 280px;

    .code-txt {
      color: rgb(107 114 128);
    }

    .code-txt1 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5rem;
      line-height: 2rem;
      font-weight: 500;
      margin-top: 10px;

    }

    .code-input {
      height: 40px;
      border: none;
      margin-top: 20px;
      width: 100%;
      padding-left: 10px;
      border-radius: 5px;
      color: rgb(107 114 128);
    }

  }

  .code-tips {
    color: rgb(107 114 128);
    font-size: 14px;
    padding: 0 15px;
  }

  .code-btn {
    width: 250px;
    border-radius: 5px;
    color: #fff;
    margin: 20px auto;

  }

  .btn-grad {
    background-image: linear-gradient(to right, #614385 0%, #516395 51%, #614385 100%)
  }

  .btn-grad {
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
  }

  .btn-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
  }


  .btn-grad1 {
    background-image: linear-gradient(to right, #FF8008 0%, #FFC837 51%, #FF8008 100%)
  }

  .btn-grad1 {
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
  }

  .btn-grad1:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
  }


}

:deep(.van-button__text) {
  color: #fff;
}


.van-popup--bottom.van-popup--round {
  background-color: #FAACA8;
  // background-color: #232B35;
  //background-image: linear-gradient(19deg, #FAACA8 0%, #DDD6F3 100%);
  background-image: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%);
}

.shibie-code {
  font-size: 14px;
  padding: 5px 10px;
  font-weight: 600;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  cursor: pointer;
  right: 0;
  z-index: 99;
  border-radius: 25px;
}

::v-deep(.van-notice-bar__content) {
  color: #F50304 !important;
  font-weight: 600;
}

.ce-shesu {
  width: 50px;
  height: 50px;
  background-image: linear-gradient(to right, #FF8008 0%, #FFC837 51%, #FF8008 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.remind-title-tips {
  font-weight: 600;
  color: #06F70C;
  margin: 10px;
}

.remind-box-title {
  margin: 10px;
  width: 80%;
  height: 40px;
  line-height: 40px;
  background: #333;
  color: #F2BE31;
  display: flex;
  justify-content: center;
  font-weight: 600;
  border-radius: 4px;
}

.remind-box-tip1 {
  width: 300px;
  // color: #F2BE31;
  margin: 20px auto 0 auto;
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.remind-box-link {
  margin: 10px auto;
  display: flex;
  justify-content: center;
  align-items: center;

}

.box-link {
  font-size: 24px;
  font-weight: 600;
  color: #F50304;
}

.box-copy {
  font-size: 14px !important;
  color: #F50304 !important;
  background: linear-gradient(#FCF518, #F3B501);
  font-weight: 700;
  text-align: center;
  border-radius: 20px;
  padding: 4px 12px;
  margin-left: 20px;
}

.remind-box-tip2 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding:0 30px;
  line-height: 28px;
  p{
    color:red;
  }
}

.remind-box-img {
  width: 150px;
  height: 150px;
  margin: 0 auto;
}

.box-tips {
  margin: 14px;
  padding: 20px;
  box-shadow: 1px 1px 2px 1px #ccc;
  border-radius: 10px;

  .tips-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  .tips-txt {
    padding: 5px;
  }
}

#spreadmsed {
  transition: opacity 0.3s ease-in-out;
}

header {

  width: 100%;
  overflow-x: hidden;
  max-width: 100vw;
  background: linear-gradient(to right, #6197B1, #B4CCF6);
  /* 添加一些阴影效果增加层次感 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 3px 2px 0 2px;
}

.tag-container {
  display: flex;
  flex-direction: column;
  // gap: 2px;
  width: 100%;
}

.tag-row {
  display: flex;
  gap: 7px;
  width: 100%;
}

.tag {
  /* 略微透明的白色背景 */
  color: #fff;
  /*padding: 8px 4px;*/
  border-radius: 4px;
  border: none;
  /* 移除边框 */
  flex: 1;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  color: #fff;
  touch-action: manipulation;
  user-select: none;
  position: relative;
  min-width: 0;
  /* 添加阴影提升视觉效果 */

}



/* 适配不同屏幕尺寸 */
@media screen and (max-width: 320px) {
  .tag-row {
    gap: 6px;
  }

  .tag {
    font-size: 20px;

  }
}

@media screen and (min-width: 321px) and (max-width: 375px) {
  .tag {
    font-size: 20px;

  }
}

@media screen and (min-width: 376px) {
  .tag {
    font-size: 20px;

  }
}

/* 适配刘海屏 */
@supports (padding-top: env(safe-area-inset-top)) {
  header {
    padding-left: calc(2px + env(safe-area-inset-left));
    padding-right: calc(2px + env(safe-area-inset-right));

  }
}

/* 禁用长按菜单 */
.tag {
  -webkit-touch-callout: none;
}

/* 优化字体渲染 */
@media screen and (-webkit-min-device-pixel-ratio: 2) {
  .tag {
    -webkit-font-smoothing: subpixel-antialiased;
  }
}

@supports (padding-top: env(safe-area-inset-top)) {
  header {
    padding-left: calc(2px + env(safe-area-inset-left));
    padding-right: calc(2px + env(safe-area-inset-right));
  }

  .header-fixed {
    padding-top: env(safe-area-inset-top);
  }
}


.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  background: linear-gradient(to right, #6197B1, #B4CCF6);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 添加占位元素的样式 */
.header-placeholder {
  height: 0;
  transition: height 0.3s ease;
}

.list {
  position: relative;
  z-index: 1;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
    /* 完全显示 */
  }

  50% {
    opacity: 0.4;
    /* 完全透明 */
  }
}

// .cebian{
//   position: fixed; /* 固定位置 */
//   right:0px; /* 距离屏幕右侧10px */
//   top: 50%; /* 定位到屏幕中间 */
//   transform: translateY(-50%); /* 垂直居中 */
//   z-index: 1000; /* 确保在页面上方显示 */

//   .today{
//     //background: rgba(255, 255, 255, 0.9); /* 白色背景，80%透明度 */
//     background-image: linear-gradient(#fffaaa, #fff000);
//     padding: 10px; /* 内边距 */
//     border-radius: 5px; /* 圆角 */
//     box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* 添加阴影效果 */
//     font-size: 16px; /* 字体大小 */
//     line-height: 1.5; /* 行高 */
//     color: red; /* 字体颜色 */
//     font-weight: bold; /* 字体加粗 */
//     text-align: center; /* 文本居中 */
//     writing-mode: vertical-rl; /* 垂直排版，文字从上到下显示 */
//     transform-origin: center; /* 确保对齐中心 */
//     // animation: blink 1s infinite; /* 闪烁动画 */
//   }
// }

.cebian {
  position: fixed;
  /* 固定位置 */
  right: 0px;
  /* 距离屏幕右侧10px */
  top: 50%;
  /* 定位到屏幕中间 */
  transform: translateY(-50%);
  /* 垂直居中 */
  z-index: 1000;
  /* 确保在页面上方显示 */

  .today {
    //background: rgba(255, 255, 255, 0.9); /* 白色背景，80%透明度 */
    //background-image: linear-gradient(#fffaaa, #fff000);
    padding: 10px;
    /* 内边距 */
    border-radius: 5px;
    /* 圆角 */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    /* 添加阴影效果 */
    font-size: 18px;
    /* 字体大小 */
    line-height: 1.8;
    /* 行高 */
    color: #fff;
    /* 字体颜色 */
    font-weight: bold;
    /* 字体加粗 */
    text-align: center;
    /* 文本居中 */
    writing-mode: vertical-rl;
    /* 垂直排版，文字从上到下显示 */
    transform-origin: center;
    /* 确保对齐中心 */
    // animation: blink 1s infinite; /* 闪烁动画 */
    background: rgba(0, 0, 0, 0.6);
  }
}

.heart {
  position: absolute;
  width: 25px;
  height: 25px;
  cursor: pointer;
  right: 0;
  z-index: 99;

}

.channelbox {
  #mse {
    background-color: #0d0d0d;
  }

  .shoucang-box {
    padding: 10px 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f8f8f8;

    .shoucang-title {
      font-size: 18px;
      font-weight: 700;
      margin-top: 10px;
    }

    .link-txt {
      font-size: 14px;
      padding: 10px;
      word-wrap: break-word;
      width: 280px;
    }

    .box-img {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;
      padding: 10px;
      background: #fff;
      border-radius: 8px;
    }

    .down-btn {
      width: 220px;
      height: 35px;
      background-image: linear-gradient(#fffaaa, #fff000) !important;
      margin-bottom: 10px;
      border-radius: 25px;
      border: none;
    }
  }

  .player_bot {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    margin-top: 1%;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 10px;
  }

  .player_bot div {
    font-size: 12px;
    text-align: center;
  }

  .player_bot div img {
    width: 25px;
    height: 25px;
    margin-bottom: 5px;
    margin-top: 5px;
  }

  .details p {
    display: inline-block;
    padding-top: 4px;
    width: 100%;
    font-size: 14px !important;
  }

  .details p img {
    width: 15px;
    height: 15px;
  }

  .weui-panel__hd {
    padding: 10px;
  }

  .qrcodelink {
    /*width: 200px; !* 定义容器宽度 *!*/
    word-wrap: break-word;
    /* 允许在单词内换行 */
    overflow-wrap: break-word;
    /* 同上，现代浏览器推荐使用 */
    white-space: normal;
    /* 允许自动换行 */
  }

  .tuijian {
    font-size: 14px;
    color: red;
    position: absolute;
    width: 100px;
    margin-top: 60px;
    margin-left: 30px;
  }

}

//     .search-box .searcn-new:nth-of-type(2) {

//   animation: bounce 1.5s ease infinite !important;
//   transform-origin: center bottom !important;

// }

@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}
.choose-box{
  // background: ##ff8260;
  height: 200px;
  width: 350px;
  border:2px solid #5f5151;
  display: flex;
  flex-direction: column;
    justify-content: center;
    align-items: center;
  .choose-pay{
    width: 320px;
    height: 40px;
    background: #ff8c31;
    color: #fff;
    margin-bottom:20px ;
    display: flex;
    justify-content: center;
    align-items: center;;
  }
  .choose-share{
    width: 320px;
    height: 40px;
    background: #493131;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;;
  }
}
.share-content{
  background: url('https://oss.ms.bihiiti.com/ms0720/images/spback.jpg');
  background-size: 100% 100%;
  height: 100Vh;
  .share-item{
    background: rgba(0, 0, 0, 0.4);
    position:absolute;
    width: 100%;
    height: 100vh;
    z-index: 9;
  }

  .card {
    width: 350px;
    height: 120px;
    margin: 0 auto;
    top:100px;
     background: #07182E;
     //background: linear-gradient(135deg, rgb(0, 255, 214) 0%, rgb(8, 226, 96) 100%);
    position: relative;
    display: flex;
    place-content: center;
    place-items: center;
    overflow: hidden;
    border-radius: 20px;
    z-index: 10;
    padding:20px;
    
  }

.card h2 {
  z-index: 1;
  color: #fff;
  font-size: 1.2em;
}

.card::before {
  content: '';
  position: absolute;
  width: 400px;
  background-image: linear-gradient(180deg, rgb(0, 183, 255), rgb(255, 48, 255));
  height: 50%;
  animation: rotBGimg 3s linear infinite;
  transition: all 0.2s linear;
}


@keyframes rotBGimg {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

  .card::after {
    content: '';
    position: absolute;
     background: #07182E;;
    //background: linear-gradient(0deg, rgba(255, 255, 255, 0.349) 0%, rgba(255, 255, 255, 0.815) 100%);
    inset: 5px;
    border-radius: 15px;
  }
  

}
.show-share-tips-box{
  width: 350px;
  padding:20px;
  display: flex;
  flex-direction: column;
    justify-content: center;
    align-items: center;


  .share-btn-cl {
    margin-top: 40px;
    border: none;
    color: #fff;
    background: linear-gradient(to bottom, #d190ff, #5e2b83);
    border-radius: 20px;
    background-size: 100% auto;
    font-family: inherit;
    font-size: 17px;
    padding: 0.6em 1.5em;
    }

    .share-btn-cl:hover {
    background-position: right center;
    background-size: 200% auto;
    -webkit-animation: pulse 2s infinite;
    animation: pulse512 1.5s infinite;
    }

    @keyframes pulse512 {
    0% {
      box-shadow: 0 0 0 0 #05bada66;
    }

    70% {
      box-shadow: 0 0 0 10px rgb(218 103 68 / 0%);
    }

    100% {
      box-shadow: 0 0 0 0 rgb(218 103 68 / 0%);
    }
    }
}

</style>